import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-panels',
    templateUrl: './block-panels.component.html',
})

export class BlockPanelsComponent extends BlockAbstractComponent implements OnInit {

}
